import { render, staticRenderFns } from "./goodsRow.vue?vue&type=template&id=2c5a8836&scoped=true&"
import script from "./goodsRow.vue?vue&type=script&lang=js&"
export * from "./goodsRow.vue?vue&type=script&lang=js&"
import style0 from "./goodsRow.vue?vue&type=style&index=0&id=2c5a8836&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5a8836",
  null
  
)

export default component.exports